import { type IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';
import { PartnerGroupRules, UserGroupRules } from 'src/graphql';

export enum SiteTabs {
  SiteDocumentation = 'site_documentation',
  Conversations = 'conversations',
  Clients = 'clients',
  MembershipInformation = 'membership_information',
  AiSummary = 'ai_summary',
  Projects = 'projects',
  Activity = 'activity',
}

export type SiteTab = {
  label: string;
  value: SiteTabs;
  /**
   * URL segment for the full-page deep link (`/sites/{id}/{slug}`). Kept separate from
   * `value` so the public URL contract does not inherit the snake_case enum values.
   */
  slug: string;
  icon: string;
  iconLibrary?: IconLibrary;
  allowedRules?: (UserGroupRules | PartnerGroupRules)[];
};

export const SITE_TABS: SiteTab[] = [
  {
    value: SiteTabs.Clients,
    slug: 'clients',
    label: 'Clients',
    icon: 'users',
    iconLibrary: 'lucide',
  },
  {
    value: SiteTabs.SiteDocumentation,
    slug: 'documentation',
    label: 'Documentation',
    icon: 'file-text',
    iconLibrary: 'lucide',
  },
  {
    value: SiteTabs.Conversations,
    slug: 'conversations',
    label: 'Conversations',
    icon: 'messages-square',
    iconLibrary: 'lucide',
  },
  {
    value: SiteTabs.MembershipInformation,
    slug: 'membership',
    label: 'Membership Information',
    icon: 'id-card',
    iconLibrary: 'lucide',
  },
  {
    value: SiteTabs.AiSummary,
    slug: 'ai-summary',
    label: 'AI Summary',
    icon: 'sparkles',
    iconLibrary: 'lucide',
    allowedRules: [UserGroupRules.AccessToAiSiteSummary],
  },
  {
    value: SiteTabs.Projects,
    slug: 'projects',
    label: 'Projects',
    icon: 'folder-open',
    iconLibrary: 'lucide',
  },
  {
    value: SiteTabs.Activity,
    slug: 'activity',
    label: 'Activity',
    icon: 'history',
    iconLibrary: 'lucide',
    allowedRules: [UserGroupRules.AccessToActivityFeedInSites],
  },
];
